import { useCallback } from 'react'
import type { ReportBucketType } from '@services/api/reports/finance.api'
import {
  getChairRoomUtilizationReport,
  type ChairRoomUtilizationReportResult,
} from '@services/api/reports/operations.api'
import { useFinanceReportQuery } from '@hooks/reports/useFinanceReportQuery'

export type ChairRoomUtilizationReportData = ChairRoomUtilizationReportResult

export type UseChairRoomUtilizationReportResult = {
  loading: boolean
  error: string | null
  data: ChairRoomUtilizationReportData | null
  bucketLabel: string
}

export function useChairRoomUtilizationReport(
  toolbarSelection: Record<string, string>,
): UseChairRoomUtilizationReportResult {
  const getBucketFromData = useCallback(
    (data: ChairRoomUtilizationReportResult): ReportBucketType =>
      data.chairTimeUsed.bucket,
    [],
  )

  return useFinanceReportQuery({
    toolbarSelection,
    fetchReport: getChairRoomUtilizationReport,
    getBucketFromData,
    errorMessage: 'Failed to load chair and room utilization data',
  })
}
